import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";

interface DetailsTabButtonsProps {
  saving: boolean;
  savingAndPreview: boolean;
  saveDisabled?: boolean;
  onSave: () => void;
  onSaveAndPreview: () => void;
  onCancel: () => void;
}

const DetailsTabButtons: React.FC<DetailsTabButtonsProps> = ({
  saving, savingAndPreview, saveDisabled, onSave, onSaveAndPreview, onCancel,
}) => {
  const { t } = useTranslation();
  const base = 'reconciliation.managerStatement.detail.pageTexts.detailsTab.otherDetails';

  return (
    <div className="p-4">
      <Button
        className="btn btn-primary me-3"
        text={t(`${base}.saveButton`)}
        disabled={saving || savingAndPreview || saveDisabled}
        loading={saving}
        onClick={onSave}
      />
      <Button
        className="btn btn-primary me-3"
        text={t(`${base}.saveAndPreviewButton`)}
        disabled={saving || savingAndPreview || saveDisabled}
        loading={savingAndPreview}
        onClick={onSaveAndPreview}
      />
      <Button
        className="btn btn-outline-secondary"
        text={t(`${base}.cancelButton`)}
        onClick={onCancel}
      />
    </div>
  );
};

export default DetailsTabButtons;
